mmf_modules.define('templates/helpers/eq',[
    'handlebars'
], function (
    Handlebars
) {
    "use strict";

    /*
        Usage:
            {{#eq test_var "hello" }}
            <span>Hello World!</span>
            {{else}}
            <span>Goodbye World!</span>
            {{/eq}}

    */
    Handlebars.registerHelper('eq', function (v1, v2, options) {
        if (arguments.length < 3) {
            throw new Error("Handlebars Helper equal needs 2 parameters");
        }

        if (v1 === v2 ) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });
});
